import * as React from 'react';
import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { connect } from 'react-redux';

import GridDayView from 'grid-day.view';
import { ICalendarAppState } from '../../redux-state';

interface IGridDayExternalProps {
    day: IDay<IEvent>;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type GridDayProps = IGridDayExternalProps & StateToProps;

export const GridDayBase: React.StatelessComponent<GridDayProps> = props => {
    return (
        <GridDayView {...props} />
    )
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(GridDayBase);